/**
 * @file product-search.js
 */
import { getResultCountHtml } from "./view-helpers";

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function updateResultCount() {
    const pagesCurrentItem = document.querySelector('.insights-display span[data-pages-current]');
    const resultsDisplay = document.getElementById('resultCount');

    if (pagesCurrentItem && resultsDisplay) {
      const pagesCurrent = parseInt(pagesCurrentItem.textContent);
      const itemsPerPage = parseInt(document.querySelector('.insights-display span[data-items-per-page]').textContent);
      const itemsTotal = parseInt(document.querySelector('.insights-display span[data-items-total]').textContent);
      resultsDisplay.innerHTML = getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal);
    } else if (resultsDisplay) {
      resultsDisplay.innerHTML = '';
    }
  }

  function updateSelectedFilters() {
    const $summary = $('#selected-filters-summary');
    $summary.empty();

    // Use dynamic selector to handle AJAX-suffixed checkbox IDs
    const selectedCheckboxes = $('input[type="checkbox"][id^="edit-field-type-target-id-"]:checked');

    if (selectedCheckboxes.length) {
      const $list = $('<ul class="selected-filters-list"></ul>');

      selectedCheckboxes.each(function () {
        const labelText = $('label[for="' + this.id + '"]').text().trim();
        const $item = $('<li class="filter-tag" data-checkbox-id="' + this.id + '"><span>' + labelText + '</span><span>×</span></li>');
        $list.append($item);
      });

      $summary.append($list);
    } else {
      //$summary.html('<em>No filters selected.</em>');
    }
  }

  function addSummaryClickHandler() {
    $('#selected-filters-summary').off('click').on('click', '.filter-tag', function () {
      const checkboxId = $(this).data('checkbox-id');
      const $checkbox = $('#' + checkboxId);

      if ($checkbox.length) {
        $checkbox.prop('checked', false).trigger('change');
      }
    });
  }

  function initFilterSummaryBehavior() {
    updateSelectedFilters();
    addSummaryClickHandler();
  }

  // Initial run on page load
  $(document).ready(function () {
    updateResultCount();
    initFilterSummaryBehavior();
  });

  // Re-run after each AJAX update (e.g., from BEF auto-submit)
  $(document).ajaxComplete(function () {
    updateResultCount();
    initFilterSummaryBehavior();
  });

})(jQuery, Drupal, drupalSettings, once);
